<template>
    <div v-if="table.id">

        <tab-navigator :table="table"></tab-navigator>
        <view-toolbar :table="table" :view="view"></view-toolbar>

        <div class="row mx-0 h-100">

            <div class="col-10">

                <phone-container v-if="model.supportMobile && model.viewModel.renderType === 'Mobile'" :view="view">

                    <template v-slot:header>
                        <div class="d-flex justify-content-between p-2">
                            <div class="col-3">
                                <back-link></back-link>
                            </div>
                            <div class="col-6 text-center">{{view.name}}</div>
                            <div class="col-3"></div>
                        </div>
                    </template>

                    <details-renderer :view="view" :table="table" :document="document" :record-id="recordId"
                                      style="height: 684px; overflow-y: scroll;"></details-renderer>

                </phone-container>

                <details-renderer v-else :view="view" :table="table" :document="document"
                                  :record-id="recordId"></details-renderer>
            </div>


            <!--            <layout-property-editor v-if="table && layout" :view-model="model.viewModel" :layout="layout" class="bg-white"-->
            <!--                                    :table="table" :config="galleryConfig"></layout-property-editor>-->

        </div>

    </div>
</template>

<script>
    import ViewService from "../services/ViewService";
    import ModelService from "../services/ModelService";
    import ShowView from "./ShowView.vue";
    import TabNavigator from "./nav/TabNavigator.vue";
    import ViewToolbar from "./toolbar/ViewToolbar.vue";
    import PhoneContainer from "../components/PhoneContainer.vue";
    import LayoutPropertyEditor from "../editor/experimental/LayoutPropertyEditor.vue";
    import DetailsRenderer from "./details/DetailsRenderer.vue";
    import BackLink from "../components/BackLink.vue";

    export default {
        name: 'DetailsContainer',
        components: {
            BackLink,
            DetailsRenderer, LayoutPropertyEditor, PhoneContainer, ViewToolbar, TabNavigator, ShowView},
        props: ['prop1', 'prop2'],
        data() {
            return {
                model: webase.model,
                viewService: new ViewService(),
                modelService: new ModelService(),
                document: null,
                view: {
                    id: null,
                    name: '',
                    view_type: '',
                    layout: null
                },
                table: {
                    id: null,
                    name: ''
                },
                recordId: null
            }
        },
        mounted() {
            window.scrollTo(0, 0)
            let viewId = this.$route.params.view_id
            this.recordId = this.$route.params.record_id

            this.viewService.get(viewId).then((response) => {
                this.view = response
                let app = response.app
                console.log('Details init app')
                webase.utils.app.initAppProperties(app)
                this.model.app = app
                this.table = webase.utils.array.get(this.model.app.tables, this.view.model_id)

                this.loadData()
            }).catch((message) => {
                console.log('error loading view')
                console.log(message)
            })
        },
        methods: {
            loadData() {

                this.modelService.getDocument(this.table, this.recordId).then((response) => {
                    this.document = response
                }).catch((message) => {
                    console.log('error loading records from table')
                    console.log(message)
                })
            },
        }
    }
</script>

<style>

</style>
